// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"221504b1","97":"9fe279fb","207":"911833f5","488":"4ede2a20","508":"5cd43c15","583":"a3d165dd","626":"414010b3","632":"6ced8a7c","741":"a9d321e8","947":"a76f4d93"}[chunkId] + ".chunk.js";
};